import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
    const token = localStorage.getItem("uk_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default client;

export const formatZAR = (n) =>
    `R${Number(n || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const cartLineTotal = (line) => {
    const mods = (line.modifiers || []).reduce((s, m) => s + Number(m.price || 0), 0);
    return (Number(line.price) + mods) * Number(line.quantity || 1);
};
